export const BLOG_API_BASE_URL = 'blogs/v3';
export const TAGS_PER_PAGE = 100;
export const AUTHORS_PER_PAGE = 100;

// Request state keys
export const CREATE_POST_TAG_REQUEST = 'CREATE_POST_TAG_REQUEST';
export const CREATE_POST_TAG_TRANSLATION_REQUEST = 'CREATE_POST_TAG_TRANSLATION_REQUEST';
export const FETCH_POST_TAGS_REQUEST = 'FETCH_POST_TAGS_REQUEST';
export const FETCH_POST_AVAILABLE_AUTHORS_REQUEST = 'FETCH_POST_AVAILABLE_AUTHORS_REQUEST';
export const FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_REQUEST = 'FETCH_POST_FEATURED_IMAGE_THUMBNAIL_URLS_REQUEST';
export const FETCH_POST_NOTIFICATIONS_EMAILS_REQUEST = 'FETCH_POST_NOTIFICATIONS_EMAILS_REQUEST';
export const FETCH_POST_SOCIAL_ACCOUNTS_REQUEST = 'FETCH_POST_SOCIAL_ACCOUNTS_REQUEST';
export const FETCH_POST_SOCIAL_AUTO_PUBLISHING_REQUEST = 'FETCH_POST_SOCIAL_AUTO_PUBLISHING_REQUEST';
export const FETCH_SOCIAL_AUTO_PUBLISH_STATUS_REQUEST = 'FETCH_SOCIAL_AUTO_PUBLISH_STATUS_REQUEST';
export const FETCH_SOCIAL_BROADCASTS_REQUEST = 'FETCH_SOCIAL_BROADCASTS_REQUEST';
export const FETCH_POST_BLOGS_REQUEST = 'FETCH_POST_BLOGS_REQUEST';
export const FETCH_BLOG_LIMIT_REQUEST = 'FETCH_BLOG_LIMIT_REQUEST';
export const FETCH_BLOG_LISTING_TEMPLATE_INFO_REQUEST = 'FETCH_BLOG_LISTING_TEMPLATE_INFO_REQUEST';
export const FETCH_BLOG_POST_LIMIT_REQUEST = 'FETCH_BLOG_POST_LIMIT_REQUEST';
export const FETCH_MLANG_BLOG_POST_LIMIT_REQUEST = 'FETCH_MLANG_BLOG_POST_LIMIT_REQUEST';
export const FETCH_BLOG_LISTING_PAGES_REQUEST = 'FETCH_BLOG_LISTING_PAGES_REQUEST';
export const PageSecurityStates = {
  FLAGGED_FOR_REVIEW: 'FLAGGED_FOR_REVIEW',
  SECURITY_VIOLATION: 'SECURITY_VIOLATION',
  CLEAR: 'CLEAR',
  NONE: 'NONE'
};
export const CONSUMER_NAME = 'blog-editor-ui';